<template>
  
  <img :src="lazySrc"
    v-intersect="{ onChange: handleIntersection }"
    :class="cssClass"
    :style="style"
    class="loading-placeholder"
    style="background-image: url('https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif'); "/>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
    },
    placeholder: String,
    cssClass: String
  },
  data () {
    return {
      lazySrc: '',
    };
  },
  computed: {
    style () {
      return this.size ? `height: ${this.size}px; width: ${this.size}px` : '';
    },
  },
  methods: {
    handleIntersection(isIntersecting) {
      if (isIntersecting)
        this.lazySrc = this.src || this.placeholder || '/img/no-photo2.c68ccc5b.png';
    }
  },
};
</script>
<style scoped>
  .loading-placeholder {
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: center;
  }
</style>